module.exports = "<div class=empty-state> <div class=empty-state__header> <i class=\"fa fa-4 {{$ctrl.icon}}\"></i> </div> <div class=empty-state__content ng-bind-html=$ctrl.content></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/empty-state/empty-state.html
// module id = k1ea
// module chunks = 1